import { ensureTypeId, ensureUri, UriOrTypeId } from '../types/uri';

export function getUri(arg: UriOrTypeId): string {
    if (ensureUri(arg, true)) return arg.uri;
    else if (ensureTypeId(arg, true)) return `${arg.type}/${arg.recordId}`;
    throw new Error(
        'Invalid uri or typeId ' +
            ('uri' in arg ? arg.uri : 'type' in arg && 'recordId' in arg ? arg.type + '/' + arg.recordId : 'undefined'),
    );
}
